import React, { useState } from "react";
import { buildMarketplaceIconUrl, getLocalMarketplaceIcon, getMarketplaceInitials } from "../utils/marketplaceUtils";
import styles from "./MarketplaceIcon.module.scss";

type TMarketplaceIconDestination = {
	Export_Destination_ID: number;
	Exchange_Name: string;
	Icon_Url?: string | null;
};

type TMarketplaceIcon = {
	destination: TMarketplaceIconDestination;
	alt?: string;
	className?: string;
	style?: React.CSSProperties;
};

export const MarketplaceIcon = ({ destination, alt, className, style }: TMarketplaceIcon) => {
	const src = buildMarketplaceIconUrl(destination);
	const [failedSrc, setFailedSrc] = useState<string | null>(null);

	const label = alt ?? destination.Exchange_Name;

	if (src && failedSrc !== src) {
		return <img src={src} alt={label} className={className} style={style} onError={() => setFailedSrc(src)} />;
	}

	const localIcon = getLocalMarketplaceIcon(destination.Export_Destination_ID);

	return (
		<span
			className={[styles.fallback, className].filter(Boolean).join(" ")}
			style={style}
			title={label}
			role="img"
			aria-label={label}>
			{localIcon ?? <span className={styles.initials}>{getMarketplaceInitials(destination.Exchange_Name)}</span>}
		</span>
	);
};

export default MarketplaceIcon;
